import { API_BASE_URL } from "~/constants";

export function resolveReportArtifactUrl(url?: string): string | null {
  const artifactUrl = url?.trim();

  if (!artifactUrl) {
    return null;
  }

  try {
    const resolvedUrl = new URL(
      artifactUrl,
      API_BASE_URL || window.location.origin,
    );

    return resolvedUrl.protocol === "http:" || resolvedUrl.protocol === "https:"
      ? resolvedUrl.href
      : null;
  } catch {
    return null;
  }
}
